var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "330px",
    height: "492px",
    viewBox: "0 0 330 492",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-91.000000, -10.000000)",
    fill: "#0078d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297,157 L297,502 L214,502 L214,157 L297,157 Z M174,231 L174,335 L91,335 L91,231 L174,231 Z M421,10 L421,334 L338,334 L338,10 L421,10 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.a7d16d667e538085723277a6599d3868.svg";
export { ForwardRef as ReactComponent };